import {JsonProperty} from '@hyperloris/tyson';
import {CCRolesType} from "./cc-roles-type";

export class CurrentUserInfo {

  @JsonProperty()
  username: string | undefined;

  @JsonProperty()
  firstName: string | undefined;

  @JsonProperty()
  lastName: string | undefined;

  @JsonProperty()
  roles: CCRolesType.Roles[] | undefined;

  @JsonProperty()
  userGroupNames: string[] | undefined;

  @JsonProperty()
  securityTeams: string[] | undefined;
}
